<template>
  <div v-if="intent">
    <v-layout style="border-bottom: 1px solid #eee;" class="mb-3">
      <v-flex form-control :class="{ 'has-error': errors.has('intentName') }" class="pa-2">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Conversation')"
          v-model="intent.intentname"
          name="intentName"
          :data-vv-as="$t('Conversation')"
          aria-describedby="Intent Name"
          v-validate="
            'required|excluded:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
          "
        />
        <span class="text-error" v-show="errors.has('intentName')">
          {{ errors.first('intentName') }}
        </span>
      </v-flex>
      <slot name="header"></slot>
    </v-layout>
    <div class="pa-2">
      <template v-for="(variable, index) in variables">
        <add-edit-variable
          v-model="variables[index]"
          :key="`${variable.name}_${index}`"
          @onDelete="onDelete(index)"
        ></add-edit-variable>
        <v-divider
          :key="`divider_${variable.name}_${index}`"
          class="my-2"
          v-if="variables.length - 1 != index"
        ></v-divider>
      </template>
      <div class="add-conversation text-xs-center" style="cursor: pointer" @click="addVariable">
        <i class="fa fa-plus middle"></i>
        {{ $t('Add Variable') }}
      </div>
    </div>
    <div class="text-xs-center">
      <div v-if="errors.has('caseB')" class="pa-2">
        <span class="red--text">{{ errors.first('caseB') }}</span>
      </div>
      <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import AddEditVariable from './AddEditVariable'
export default {
  props: ['value'],
  components: {
    AddEditVariable
  },
  data() {
    return {
      excludedName: '',
      intent: null,
      variables: []
    }
  },
  mounted() {
    this.intent = this.value
    if (this.intent.answer.length == 0 || this.intent.answer[0].length == 0) {
      this.intent.answer = [
        [
          {
            variables: []
          }
        ]
      ]
      //   vm.$emit('input', vm.intent)
    }

    this.resetVariables(this.intent.answer[0][0])
    this.intent = JSON.parse(JSON.stringify(this.value))
    this.cached_intent = JSON.stringify(this.intent)
  },
  methods: {
    addVariable() {
      this.variables.push({
        name: null,
        value: null,
        istransaction: false
      })
    },
    resetVariables(answer) {
      var variables = []

      if (answer.variables.length > 0) {
        variables = answer.variables.map(el => {
          var val = el.text.split('=')
          return {
            name: val[0].trim(),
            value: val[1].trim(),
            istransaction: el.istransaction == true ? el.istransaction : false
          }
        })
      }

      this.variables = variables
    },
    onCancel() {
      this.intent = JSON.parse(this.cached_intent)
      this.$emit('onCancel')
    },
    onSave() {
      var vm = this
      var data = JSON.parse(JSON.stringify(this.intent))

      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }

        var variables = []
        if (vm.variables.length > 0) {
          variables = vm.variables
            .map(el => {
              if (el.value && el.value != '') {
                return {
                  text: `${el.name}=${el.value}`,
                  height: 0,
                  istransaction: el.istransaction
                }
              }
            })
            .filter(el => {
              return el != null
            })
        }

        data.answer[0][0].variables = variables

        vm.cached_intent = JSON.stringify(data)

        vm.$emit('input', data)
        vm.$emit('onSave', data)
      })
    },
    onDelete(index) {
      this.variables.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/VariableManage.vue